import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../assets/svg/iconSelect.svg',
})
export class IconSelectComponent {}
